import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <nav className="navbar">
        <Link to="/" className="logo-link">
          <div className="logo">Mycelo</div>
        </Link>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/industries">Industries</Link></li>
          <li><Link to="/solution">Solutions</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li><Link to="/api">API</Link></li>
        </ul>
        <Link to="/contact?demo=true" className="cta-button-link">
          <button className="cta-button">Request a Demo</button>
        </Link>
      </nav>
    </header>
  );
};

export default Header;